import React from 'react';
import { Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Header from '../../Header';
import Benefit from './Benefit';
import Sequential from './Sequential';
import Problem from './Problem';
import Objective from './Objective';
import Options from './Options';
import OfferMenu from './OfferMenu';
import UsingMenu from './UsingMenu';
import Preference from './Preference';
import Intervention from './Intervention';
import Assessing from './Assessing';
import Predictive from './Predictive';
import Understanding from './Understanding';
import Strategies from './Strategies';
import Other from './Other';

export default class MoreIndex extends React.Component {
  isActive = term => {
    const path = this.props.location.pathname.split('/').pop();
    return path === term;
  }

  render() {
    return (
     <section>
      <Header {...this.props} /> 
      <div className="container has-text-centered">
         <section className="section">
          <div className="container has-text-left">
            <div className="columns is-desktop">
              <div className="column is-4 is-hidden-mobile is-hidden-tablet-only">
                <aside className="menu">
                  <ul className="menu-list">
                    <li><Link to="/more/benefit" className={classNames({
                      'is-active': this.isActive('benefit')
                    })}>Benefits of Measure-based Guidance</Link></li>
                    <li><Link to="/more/sequential" className={classNames({
                      'is-active': this.isActive('sequential')
                    })}>Sequential Care Model</Link></li>
                    <li><Link to="/more/problem" className={classNames({
                      'is-active': this.isActive('problem')
                    })}>Problem I Want Treated</Link></li>
                    <li><Link to="/more/objective" className={classNames({
                      'is-active': this.isActive('objective')
                    })}>Agree on Treatment Objective</Link></li>
                    <li><Link to="/more/options" className={classNames({
                      'is-active': this.isActive('options')
                    })}>What Options Should I Consider?</Link></li>
                    <li><Link to="/more/menu" className={classNames({
                      'is-active': this.isActive('menu')
                    })}>Offer Menu of Reasonable Choices</Link></li>
                    <li><Link to="/more/using" className={classNames({
                      'is-active': this.isActive('using')
                    })}>Using the Menu of Reasonable Choice</Link></li>
                    <li><Link to="/more/preference" className={classNames({
                      'is-active': this.isActive('preference')
                    })}>My Preference</Link></li>
                    <li><Link to="/more/intervention" className={classNames({
                      'is-active': this.isActive('intervention')
                    })}>Intervention</Link></li>
                    <li><Link to="/more/assessing" className={classNames({
                      'is-active': this.isActive('assessing')
                    })}>Assessing Outcome</Link></li>
                    <li><Link to="/more/predictive" className={classNames({
                      'is-active': this.isActive('predictive')
                    })}>Predictive Value of 2 Week Outcome</Link></li>
                    <li><Link to="/more/understanding" className={classNames({
                      'is-active': this.isActive('understanding')
                    })}>Understanding Your Report</Link></li>
                    <li><Link to="/more/strategies" className={classNames({
                      'is-active': this.isActive('strategies')
                    })}>Basic Self Directed Strategies</Link></li>
                    <li><Link to="/more/other" className={classNames({
                      'is-active': this.isActive('other')
                    })}>Other Resources</Link></li>
                    </ul>
                </aside>
              </div>
              <div className="column">
                <Switch>
                  <Route path="/more/benefit" component={Benefit} />
                  <Route path="/more/sequential" component={Sequential} />
                  <Route path="/more/problem" component={Problem} />
                  <Route path="/more/objective" component={Objective} />
                  <Route path="/more/options" component={Options} />
                  <Route path="/more/menu" component={OfferMenu} />
                  <Route path="/more/using" component={UsingMenu} />
                  <Route path="/more/preference" component={Preference} />
                  <Route path="/more/intervention" component={Intervention} />
                  <Route path="/more/assessing" component={Assessing} />
                  <Route path="/more/predictive" component={Predictive} />
                  <Route path="/more/understanding" component={Understanding} />
                  <Route path="/more/strategies" component={Strategies} />
                  <Route path="/more/other" component={Other} />
                </Switch>    
              </div>
            </div>
          </div>
        </section>                
      </div>
    </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Index.js